module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_02-4-b07bcb6559ef41c263740dea8744b173.png";